import { Injectable, signal } from '@angular/core';
import {UserInterfaces} from '../interfaces/user.interfaces';

@Injectable({ providedIn: 'root' })
export class UserStateService {
  user = signal<UserInterfaces>({});
}
